import $ from 'jquery';
import PackAction from './PackAction.es6';
import Modaller from "./../modaller";

export default class PackCloneAction extends PackAction {
    constructor(opts) {
        super(opts);
    }

    getTitleKey() {
        return 'packPage.dialogs.clone.title';
    }

    _showModal(modal) {
        modal.setTitle(this.l18n.get(this.getTitleKey()));
        modal.centerFooterButtons();
        modal.addFooterLink(this.l18n.get('button.clone'), "btn btn-primary btn-ok", `${Flashcards.root}/set/_${this.opts.packId}/clone`);
        modal.addFooterButton(this.l18n.get('button.cancel'), "btn btn-secondary btn-cancel", function () {
            modal.close();
        });

        this._onModalShown();
    }

    execute() {
        Modaller.showRemote(`${Flashcards.root}/set/${this.opts.packId}/clone.ajax`
            , $.proxy(this._showModal, this)
            , (xhr) => {
                if (xhr.status !== 403) {
                    return;
                }
                this._showForbidden('packPage.dialogs.forbidden.clone.text', 'packPage.dialogs.forbidden.clone.alert');
            });
    }
}
